// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout'
import { roterPre } from '@/settings'
const orderRouter =
  {
    path: `${roterPre}/protection`,
    name: 'protection',
    meta: {
      icon: 'dashboard',
      title: '维权'
    },
    alwaysShow: true,
    component: Layout,
    redirect: `${roterPre}/appraisal`,
    children: [
      {
        path: 'list',
        name: 'protectionList',
        meta: {
          title: '维权列表',
          noCache: true
        },
        component: () => import('@/views/protection/index')
      },
      {
        path: 'status/:id?/:edit?',
        component: () => import('@/views/protection/status'),
        name: 'protectionStatus',
        meta: { title: '添加状态', noCache: true, activeMenu: `${roterPre}/protection/list` },
        hidden: true
      },
    ]
  }

export default orderRouter
